export type RiskSeverity = 'high' | 'moderate' | 'low';
export type RiskGroup = 'checkboxConditions' | 'medicalConditions' | 'slider' | 'lifestyle' | 'medications' | 'symptomDuration' | 'freeTextPresent' | 'radioCondition';

export interface RiskFactor {
  key: string;
  label: string;
  group: RiskGroup;
  severity: RiskSeverity;
  detail?: string;
}

export interface MedicalHistoryRiskSummary {
  high: RiskFactor[];
  moderate: RiskFactor[];
  low: RiskFactor[];
  hasAnyRisk: boolean;
}

export type ClinicalContextSubGroup = 'primary' | 'fitzpatrick';
export type ClinicalContextFormatter = 'text' | 'boolean' | 'radio';

export interface ClinicalContextItem {
  key: string;
  label: string;
  subGroup: ClinicalContextSubGroup;
  formatter?: ClinicalContextFormatter;
  value?: any;
  displayValue?: string;
}

export interface ClinicalContextGroups {
  primary: ClinicalContextItem[];
  fitzpatrick: ClinicalContextItem[];
}

export interface MedicalHistoryRiskSummaryWithDetail {
  high: RiskFactor[];
  moderate: RiskFactor[];
  low: RiskFactor[];
  hasAnyRisk: boolean;
  clinicalContext: ClinicalContextGroups;
}

/**
 * Single source of truth for the risk-factor keys that belong to the "allergy"
 * sub-bucket of the Conditions category. The service emits a card with the
 * allergic-environmental-symptoms key when it aggregates the symptom cluster,
 * and the quick-scan component checks every Conditions risk factor against
 * this set so allergy items render in their own sub-section. Adding a new
 * allergy factor here automatically updates both sides.
 */
export const ALLERGIC_ENVIRONMENTAL_SYMPTOMS_KEY = 'allergicEnvironmentalSymptoms';
export const ALLERGY_FACTOR_KEYS = [
  'seasonalAllergies',
  'drugAllergies',
  'otherAllergies',
  'allergySymptoms',
  ALLERGIC_ENVIRONMENTAL_SYMPTOMS_KEY
] as const;
